import { instance } from "libs/api";

import { ApiRoutesOrders } from "../../constants";
import { OrderDetails } from "../../orders.types";

export const requestOrdersDetailsByIds = async (
  orderIds: string[]
): Promise<OrderDetails[]> => {
  return await instance.post(ApiRoutesOrders.OrderDetails, { orderIds });
};
